import { listKeyitem } from './../../../../shared/Models/SelectItems';
import { FormsFieldService } from './../../services/forms-fields.service';
import { FormFields } from '../../models/form.field';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbComponentStatus, NbDialogRef } from '@nebular/theme';
import { SelectItems } from '../../../../shared/Models/SelectItems';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateFieldComponent implements OnInit {
  requiredCreateDate: listKeyitem[] = [];
  formFields: FormFields = {} as FormFields;
  users: any[];
  legals: any[];
  userSectionFlg: boolean;
  legalSectionFlg: boolean;
  userEscalationSectionFlg: boolean;
  escalDays: number;
  escaleHours: number;
  formMasterId: number;
  finishLoading: boolean;
  sectionId: number;
  constructor(
    private service: FormsFieldService,
    private route: ActivatedRoute,
    private toastrService: NbToastrService,
    private router: Router,
    private diag: NbDialogRef<CreateFieldComponent>
  ) {}
  timeType = [
    { name: 'شهر', id: 1 },
    { name: 'يوم', id: 2 },
    { name: 'ساعه', id: 3 },
  ];
  assignUserTypes = [
    { name: 'Personality', id: 1 },
    { name: 'Legal', id: 2 },
    { name: 'User Group', id: 3 },
    { name: 'RoleGroup', id: 5 },
  ];
  escalationMethods = [
    { name: 'One Level Up', id: 1 },
    { name: 'Multi Level Up', id: 2 },
    { name: 'Personal', id: 3 },
  ];
  ngOnInit() {
    this.formFields.formMasterId = this.formMasterId;
    this.formFields.sectionId = this.sectionId;
     this.loadRequiredCreateDate();
    // this.phase.workFlowId = this.route.snapshot.params.id;
    // this.phase.escalationVm = {} as Escalation;
    // this.phase.optimal = {} as PhaseDateTime;
    // this.phase.normal = {} as PhaseDateTime;
  }
  loadRequiredCreateDate() {
    this.service.getCreateNew().subscribe((res) => {
      this.requiredCreateDate = res;
      this.finishLoading = true;
    });
  }

  addNewPhase() {
    this.service.post(this.formFields).subscribe((res) => {});
  }
  dropdownChange($event) {
    switch ($event) {
      case 1:
        this.initalize();
        this.userSectionFlg = true;
        this.service.getPhaseUsers(1).subscribe((res) => {
          this.users = res;
        });
        // this.users = [{ name: 'ali', id: 2 }];
        break;
      case 2:
        this.initalize();
        this.legalSectionFlg = true;
        this.service.getPhaseUsers(2).subscribe((res) => {
          this.legals = res;
        });
        break;
      default:
        this.initalize();
    }
  }
  escalationChange($event) {
    switch ($event) {
      case 3:
        if (this.users == null || this.users.length === 0) {
          this.service.getPhaseUsers(1).subscribe((res) => {
            this.users = res;
          });
        }
        this.userEscalationSectionFlg = true;
        break;
      default:
        this.userEscalationSectionFlg = false;
    }
  }

  initalize() {
    this.userSectionFlg = false;
    this.legalSectionFlg = false;
  }
  save() {
    this.service.post(this.formFields).subscribe((res) => {
      const position = 'bottom-right';
      this.toastrService.success(`add field ${this.formFields.name} successfully`, 'success', {duration: 4000});
      this.diag.close('true');
    });
  }
  showToast(position, message, status: NbComponentStatus) {
    this.toastrService.show(message, '', { position, status });
  }
  back() {
    const route = ['workflow'];
    this.router.navigate(route);
  }
}
